'use client';

import { memo } from 'react';

import type { Locale } from '../../Entities/Locale/Locale.entity';
import { LOADING_TAGS } from './Loading.constants';

import styles from './Loading.module.css';

type Props = {
  locale?: Locale;
};

export const Loading = memo(({ locale = 'uk' }: Props) => {
  const tags = LOADING_TAGS[locale];
  const randomTag = tags?.length ? tags[Math.floor(Math.random() * tags.length)] : undefined;

  return (
    <div className={styles.wrapper}>
      {randomTag && <div className={styles.tag}>{randomTag}</div>}
      <div className={styles.loader}>
        {['0', '1', '2', '3', '4'].map(value => (
          // @ts-expect-error // not sure exactly what this is, but assuming it has a purpose
          <div key={`dot-${value}`} className={styles.dot} style={{ '--index': value }} />
        ))}
      </div>
    </div>
  );
});

Loading.displayName = 'Loading';
